import { z } from 'zod';
import { RoadmapHorizon } from './roadmap.js';
/** Feature-request lifecycle status (#17). */
export const FeatureRequestStatus = z.enum(['open', 'under_review', 'planned', 'declined', 'shipped']);
/**
 * A customer/internal feature request that users upvote (#17). `upvoteCount` is a
 * denormalized counter maintained in the vote/unvote transaction; the AI-proposed
 * roadmap ranking (#18) reads it. `myVote` is resolved per-request for the caller.
 */
export const FeatureRequest = z.object({
    id: z.string(),
    title: z.string(),
    description: z.string().nullable(),
    status: FeatureRequestStatus,
    upvoteCount: z.number(),
    customerId: z.string().nullable(),
    customerName: z.string().nullable().optional(), // resolved on reads
    createdById: z.string().nullable(),
    roadmapItemId: z.string().nullable(), // set once converted to a roadmap item
    createdAt: z.string(),
    updatedAt: z.string(),
    myVote: z.boolean().optional(), // whether the current user has upvoted
});
export const CreateFeatureRequestInput = z.object({
    title: z.string().min(1).max(300),
    description: z.string().optional(),
    status: FeatureRequestStatus.optional(),
    customerId: z.string().optional(),
});
export const UpdateFeatureRequestInput = CreateFeatureRequestInput.partial().extend({
    // Nullable so the customer attribution can be CLEARED via edit.
    customerId: z.string().nullable().optional(),
});
/** Convert a feature request into a roadmap item (default) or a ticket. */
export const ConvertFeatureRequestInput = z.object({
    target: z.enum(['roadmap', 'ticket']),
    horizon: RoadmapHorizon.optional(), // roadmap target horizon (default 'next')
    entityType: z.enum(['feature', 'initiative']).optional(), // roadmap entity type (default 'feature')
});
//# sourceMappingURL=feature-request.js.map